var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAiText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5988 39.2734H42.0977V0H48.5988V39.2734Z",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7315 39.2734H27.1237L16.9457 9.85826L6.66103 39.2734H0L13.7484 0.0532227H20.0897L33.7315 39.2734ZM20.4627 26.8039L22.008 31.1203H11.83L13.3221 26.8039H20.4627Z",
    fillOpacity: 0.9
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiText);
export default __webpack_public_path__ + "static/media/aiText.2b00373324295be1e9cf39c83a9a23f9.svg";
export { ForwardRef as ReactComponent };